import { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import inlineLogo from '../../Assets/landing/inline-logo.png'
import fb from '../../Assets/landing/fb.png'
import insta from '../../Assets/landing/insta.png'
import msg from '../../Assets/landing/message.png'

/**
 * Shared marketing navbar. Router links for Features/Pricing/Blog, and an
 * FAQ link that scrolls in place on the home page or navigates to /#faq.
 */
export default function MarketingNav({ onSupportClick }) {
    const navigate = useNavigate()
    const location = useLocation()
    const [navOpen, setNavOpen] = useState(false)

    // Prevent background scroll when mobile nav is open
    useEffect(() => {
        if (navOpen) {
            const previousOverflow = document.body.style.overflow
            const previousHtmlOverflow = document.documentElement.style.overflow

            document.body.style.overflow = 'hidden'
            document.documentElement.style.overflow = 'hidden'

            return () => {
                document.body.style.overflow = previousOverflow
                document.documentElement.style.overflow = previousHtmlOverflow
            }
        }

        return undefined
    }, [navOpen])

    const goToFaq = () => {
        if (location.pathname === '/') {
            const el = document.getElementById('faq')
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        } else {
            navigate('/#faq')
        }
    }

    const closeAnd = (fn) => () => {
        setNavOpen(false)
        fn()
    }

    return (
        <>
            <div className="app-navbar">
                <div className="app-navbar-inner">
                    <div className="app-navbar-left">
                        <Link to="/">
                            <img
                                src={inlineLogo}
                                alt="First Dance wedding planning app logo"
                                className="app-navbar-logo"
                            />
                        </Link>
                    </div>
                    <div className="app-navbar-right">
                        <Link className="app-navbar-link" to="/features">
                            Features
                        </Link>
                        <Link className="app-navbar-link" to="/pricing">
                            Pricing
                        </Link>
                        <Link className="app-navbar-link" to="/blog">
                            Blog
                        </Link>
                        <button className="app-navbar-link" type="button" onClick={goToFaq}>
                            FAQ
                        </button>
                        <button
                            className="app-navbar-cta"
                            type="button"
                            onClick={() => navigate('/redirect')}
                        >
                            Sign up
                        </button>
                    </div>
                    <div
                        className={navOpen ? 'nav-icon-1 open-burger' : 'nav-icon-1'}
                        onClick={() => setNavOpen(!navOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            {navOpen && (
                <nav className="mobile-nav">
                    <button
                        type="button"
                        className="mobile-nav-link"
                        onClick={closeAnd(() => navigate('/features'))}
                    >
                        Features
                    </button>
                    <button
                        type="button"
                        className="mobile-nav-link"
                        onClick={closeAnd(() => navigate('/pricing'))}
                    >
                        Pricing
                    </button>
                    <button
                        type="button"
                        className="mobile-nav-link"
                        onClick={closeAnd(() => navigate('/blog'))}
                    >
                        Blog
                    </button>
                    <button type="button" className="mobile-nav-link" onClick={closeAnd(goToFaq)}>
                        FAQ
                    </button>
                    <button
                        type="button"
                        className="mobile-nav-cta"
                        onClick={closeAnd(() => navigate('/redirect'))}
                    >
                        Sign up
                    </button>

                    <div className="mobile-nav-social-row">
                        <a href="https://www.facebook.com/firstdanceapp" target="_blank" rel="noreferrer">
                            <img
                                className="app-footer-social-icon"
                                src={fb}
                                alt="First Dance wedding planning app on Facebook"
                            />
                        </a>
                        <a href="https://www.instagram.com/firstdanceapp/" target="_blank" rel="noreferrer">
                            <img
                                className="app-footer-social-icon"
                                src={insta}
                                alt="First Dance wedding planner app on Instagram"
                            />
                        </a>
                        {onSupportClick && (
                            <img
                                className="app-footer-social-icon app-footer-social-icon-clickable"
                                src={msg}
                                alt="First Dance wedding planning app help"
                                onClick={closeAnd(onSupportClick)}
                            />
                        )}
                    </div>
                </nav>
            )}
        </>
    )
}
